import { render, staticRenderFns } from "./PastefyEmbed.vue?vue&type=template&id=7dd3fc92&scoped=true&"
import script from "./PastefyEmbed.vue?vue&type=script&lang=js&"
export * from "./PastefyEmbed.vue?vue&type=script&lang=js&"
import style0 from "./PastefyEmbed.vue?vue&type=style&index=0&id=7dd3fc92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd3fc92",
  null
  
)

export default component.exports